module.exports = __webpack_public_path__ + "img/team-1-6.c54e83dc.jpeg";